import type { TooltipProps } from "@mui/material";

/**
 * Slot styling that turns a MUI `Tooltip` into a bare host for a banner: no
 * padding, transparent/borderless, so the element passed as the tooltip `title`
 * IS the popup (e.g. `<SmsNotEnabledBanner />` as a gated-control tooltip).
 */
export const bannerTooltipSlotProps: TooltipProps["slotProps"] = {
  tooltip: {
    sx: {
      p: 0,
      maxWidth: 360,
      backgroundColor: "transparent",
      border: "none",
    },
  },
};
